import axiosInstance from './axiosInstance';

const BASE = (pid) => `/plants/${pid}/ready-products`;

export const getProducts = async (pid, params) => {
  return await axiosInstance.get(BASE(pid), { params });
};

export const createProduct = async (pid, data) => {
  return await axiosInstance.post(BASE(pid), data);
};

export const updateProduct = async (pid, rpid, data) => {
  return await axiosInstance.put(`${BASE(pid)}/${rpid}`, data);
};

export const deleteProduct = async (pid, rpid) => {
  return await axiosInstance.delete(`${BASE(pid)}/${rpid}`);
};